import React from 'react';
import { ActivityIndicator, StyleSheet, View } from 'react-native';
import { BrandLogo } from '../components/BrandLogo';
import { colors, spacing } from '../theme/tokens';

// Écran d'attente neutre (ex. pendant la vérification du profil au démarrage). Évite un flash
// de l'app avant l'éventuelle étape « date de naissance ».
export function AppLoadingScreen() {
  return (
    <View style={styles.container} testID="app-loading">
      <BrandLogo size={56} />
      <ActivityIndicator color={colors.electric} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: colors.grey50, alignItems: 'center', justifyContent: 'center', gap: spacing.lg },
});
